export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  domc.addType('web_widget', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'web',
          tagName: 'div',
          src: 'https://responsivedesign.is/examples/',
          width: '100%',
          height: '100%',
          traits: [
            {
              type: 'text',
              label: 'src',
              name: 'src',
              changeProp: 1
            }
          ]
        }),
        init() {
          this.listenTo(this, 'change:src', this.updateSrc);
        },
        toHTML() {
          //todo to html
          return this.view.el.getAttribute('data-gjs-type') == 'web_widget'
            ? this.view.el.outerHTML
            : '';
        },
        updateSrc() {
          this.view.getIframe().src = this.createUri();
        },
        createUri() {
          return this.get('src');
        }
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName == 'div') {
            result = { type: 'web_widget' };
          }
          return result;
        }
      }
    ),
    view: defaultView.extend({
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },

      getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');
          if (this.model.get('src') != 'https://responsivedesign.is/examples/') {
            ifrm.src = this.model.createUri();
          } else {
            ifrm.src = 'https://responsivedesign.is/examples/';
          }
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style.border = 'none;';
          ifrm.style.overflow = 'scroll';
          ifrm.scrolling = 'yes';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },

      render(...args) {
        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('IFRAME').length == 0) {
          this.el.appendChild(this.getIframe());
        }
        return this;
      }
    })
  });
};



// WEBPACK FOOTER //
// ./src/plugins/web/components.js